export const FILE_NAME = "assets/customization_app.js";
export const CUSTOMIZATION_APP = "customization_app";
export const PRODUCTION = "production";

export const PAYOUT_TEMPLATE_HELP_URL =
  "https://runapay.zendesk.com/hc/en-gb/articles/16748251131037-How-to-create-payout-selection-templates";
export const REDEMPTION_TEMPLATE_HELP_URL =
  "https://runapay.zendesk.com/hc/en-gb/articles/16748212211101-How-to-create-redemption-templates";
